// initial state
// shape: [{ user, properties }]
const state = () => ({
  showModal: false,
  itemId: null,
  type: "info",
  showPrices: false,
});

// getters
const getters = {
  showModal: (state) => state.showModal,
  itemId: (state) => state.itemId,
  type: (state) => state.type,
  showPrices: (state) => state.showPrices,
};

// actions
const actions = {};

// mutations
const mutations = {
  showModal(state) {
    state.showModal = true;
  },
  setType(state, type) {
    state.type = type;
  },
  hideModal(state) {
    state.showModal = false;
  },
  setItemId(state, itemId) {
    state.itemId = itemId;
  },
  setShowPrices(state, showPrices) {
    state.showPrices = showPrices;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
